import logger from "flow/logger";
import { getString, getBool, getUrl } from "flow/manifests/metaParserHelper";
import environment from "flow/configuration/environment";
import { IProductEntry } from "./IProductEntry";
import { IProductEntryMeta } from "./IProductEntryMeta";

export default class ProductEntry implements IProductEntry {
    id: string;
    name: string;
    isActive: boolean;
    runtimeContext: string;
    configurationProvider: string;
    broken: boolean = false;
    external: boolean = false;

    constructor(entryData: Partial<IProductEntryMeta>) {
        this.id = getString("Id", entryData, undefined);
        this.name = getString("Name", entryData, undefined);

        if (environment.get(environment.keys.useProductSelector)) {
            this.isActive = getBool("IsActive", entryData, false);
        } else {
            this.isActive = false;
        }

        this.runtimeContext = getString("VisibleInRuntimeContext", entryData, undefined);
        this.configurationProvider = getUrl("ConfigurationProvider", entryData);

        this.validate();
    }

    validate = () => {
        if (!this.id) {
            throw new Error("Product is missing an id in the configuration. Will not be used until it is fixed.");
        }

        if (!this.name) {
            logger.log("Product " + this.id + " is missing a name in the configuration. Will default to id.");
            this.name = this.id;
        }
    };
}
